




































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import EventBus, { eventTypes } from '@/utils/EventBus'
import { Timer } from '@/services/Guests'

@Component
export default class TimerComponent extends Vue {
  @Prop({ required: true }) public now!: number
  @Prop({ required: true }) public userId!: string
  @Prop({ required: true }) public timer!: Timer | null
  @Prop({ required: true, default: false }) public isFinished!: boolean

  public mm: number | null = null
  public ss: number | null = null
  public countdown: string | null = null
  public showCreateTimer = false

  showTimerScreen() {
    this.showCreateTimer = true
    this.$nextTick(() => {
      ;(this.$refs.inputMM as HTMLInputElement).focus()
    })
  }

  get timerValid() {
    return (
      (this.mm === null || (this.mm >= 0 && this.mm <= 59)) &&
      (this.ss === null || (this.ss >= 0 && this.ss <= 59))
    )
  }

  get timerDuration() {
    if (!this.mm) {
      this.mm = 0
    }

    if (!this.ss) {
      this.ss = 0
    }

    return 60 * this.mm + 1 * this.ss
  }

  startTimer() {
    // waiters will sometimes refresh the page
    // so save timer in localstorage
    const timerStartedOn = new Date().getTime()
    const duration = this.timerDuration
    const timer: Timer = {
      userId: this.userId,
      startedOn: timerStartedOn,
      duration,
      endsOn: timerStartedOn + duration * 1000,
    }

    this.cleanForm()
    EventBus.$emit(eventTypes.startTimer, timer)
  }

  stopTimer() {
    this.cleanForm()
    EventBus.$emit(eventTypes.stopTimer, this.userId)
  }

  cleanForm() {
    this.showCreateTimer = false
    this.mm = null
    this.ss = null
    this.countdown = ''
  }

  @Watch('now')
  handleTimerChange() {
    if (!this.timer || this.now > this.timer.endsOn) {
      this.countdown = null
      return
    }

    const timeLeft = this.timer.endsOn - this.now
    this.countdown = new Date(timeLeft).toISOString().substr(14, 5)
  }
}
